import { render } from "./HighchartPieChart.vue?vue&type=template&id=e38b3e90&scoped=true&ts=true"
import script from "./HighchartPieChart.vue?vue&type=script&lang=ts"
export * from "./HighchartPieChart.vue?vue&type=script&lang=ts"

import "./HighchartPieChart.vue?vue&type=style&index=0&id=e38b3e90&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e38b3e90"]])

export default __exports__